export default "__VITE_ASSET__fcbd3826__"